// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class ChangePasswordRequestModel {
    'oldPassword': string;
    'newPassword': string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof ChangePasswordRequestModel>> = [
        {
            "name":     "oldPassword",
            "baseName": "oldPassword",
            "type":     "string"
        },
        {
            "name":     "newPassword",
            "baseName": "newPassword",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return ChangePasswordRequestModel.attributeTypeMap;
    }
}
